import { observer } from "mobx-react-lite";

import { IconFileInfo } from "@synthesis/shared-icons";
import { Button, Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

import { useStores } from "../../store";

const InformationButton = observer(({ onClick }: { onClick?: () => void }) => {
  const { generalStore } = useStores();

  return (
    <Tooltip arrowSide="bottom" description="Свойства и версии">
      <Button
        theme="text"
        disabled={generalStore.checkedFiles.size !== 1}
        onClick={onClick}
        leftIcon={
          <IconFileInfo data-cy="informationButton-iconFileInfo" className={cn("size-5", generalStore.checkedFiles.size !== 1 && "text-[#d0c6c3]")} />
        }
      />
    </Tooltip>
  );
});

export default InformationButton;
